export const PAF_TEMPLATE_OPTIONS_LEGACY = [
  { value: 'PAFAviva', label: 'PAFAviva' },
  { value: 'PAFCAA', label: 'PAFCAA' },
  { value: 'PAFCoachman', label: 'PAFCoachman' },
  { value: 'PAFCommonwell', label: 'PAFCommonwell' },
  { value: 'PAFEchelon', label: 'PAFEchelon' },
  { value: 'PAFEconomical', label: 'PAFEconomical' },
  { value: 'PAFFacility', label: 'PAFFacility' },
  { value: 'PAFGore', label: 'PAFGore' },
  { value: 'PAFIntact', label: 'PAFIntact' },
  { value: 'PAFJevco', label: 'PAFJevco' },
  { value: 'PAFMax', label: 'PAFMax' },
  { value: 'PAFPafco', label: 'PAFPafco' },
  { value: 'PAFPembridge', label: 'PAFPembridge' },
  { value: 'PAFPeaceHills', label: 'PAFPeaceHills' },
  { value: 'PAFPortage', label: 'PAFPortage' },
  { value: 'PAFSEMutual', label: 'PAFSEMutual' },
  { value: 'PAFSGI', label: 'PAFSGI' },
  { value: 'PAFTravelers', label: 'PAFTravelers' },
  { value: 'PAFUnica', label: 'PAFUnica' },
  { value: 'PAFWawanesa', label: 'PAFWawanesa' },
];

export const PAF_TEMPLATE_OPTIONS = [
  { value: 'PAFAviva', label: 'PAFAviva' },
  { value: 'PAFCoachman', label: 'PAFCoachman' },
  { value: 'PAFCommonwell', label: 'PAFCommonwell' },
  { value: 'PAFEconomical', label: 'PAFEconomical' },
  { value: 'PAFFacility', label: 'PAFFacility' },
  { value: 'PAFGore', label: 'PAFGore' },
  { value: 'PAFIntact', label: 'PAFIntact' },
  { value: 'PAFJevco', label: 'PAFJevco' },
  { value: 'PAFMax', label: 'PAFMax' },
  { value: 'PAFPafco', label: 'PAFPafco' },
  { value: 'PAFPeaceHills', label: 'PAFPeaceHills' },
  { value: 'PAFPembridge', label: 'PAFPembridge' },
  { value: 'PAFPortage', label: 'PAFPortage' },
  { value: 'PAFSGI', label: 'PAFSGI' },
  { value: 'PAFTravelers', label: 'PAFTravelers' },
  { value: 'PAFUnica', label: 'PAFUnica' },
  { value: 'PAFWawanesa', label: 'PAFWawanesa' },
  { value: 'PAFOptimum', label: 'PAFOptimum' },
];
